import React, { useEffect, useState } from "react";
import { axiosInstance } from "../../context/axiosInstance";
import { TrendingsPage } from "./TrendingsPage";
import { TrendingProvider } from "./components/chart/context/TrendingContext";

const index = () => {
	const [ihPathLoaded, setIhPathLoaded] = useState<boolean>(false);

	useEffect(() => {
		const getIhPath = async () => {
			const resp = await axiosInstance.get("/backend/ih-path");
			localStorage.setItem("ihPath", resp.data);
			setIhPathLoaded(true);
		};
		getIhPath().then(() => {
			console.log("ih path loaded");
		});
	}, []);

	if (!ihPathLoaded) {
		return (
			<div className={"d-flex justify-content-center align-items-center"}>
				Loading...
			</div>
		);
	}

	return (
		<TrendingProvider>
			<TrendingsPage />
		</TrendingProvider>
	);
};

export default index;
